import gsap from "gsap";

export const animateH2Elements = (elements) => {
  elements.forEach((element, elementIndex) => {
    gsap.set(element, { 
      opacity: 0,
      duration: 0.5,
    });

    gsap.to(element, { 
      opacity: 1,
      delay: elementIndex * 0.9,
      ease: "power2.inOut",
    });
  });
};

export const createRippleEffect = (buttonRef) => {
  if (!buttonRef || !buttonRef.current) return;

  const tl = gsap.timeline({ repeat: -1 });

  for (let i = 0; i < 3; i++) {
    tl.to(buttonRef.current, {
      duration: 12,
      ease: 'power2.out'
    }, i * 0.3);
  }

  tl.to(buttonRef.current, {
    duration: 0.1,
    ease: 'power2.in'
  }, "+=0.5");
};

// export const aboutUsImageAnimation = () => {
//   return gsap.fromTo(".about-us", 
//     { scale: 0, borderRadius: "0" }, 
//     {
//       scrollTrigger: {
//         trigger: "body",
//         start: "top top",
//         end: "bottom bottom",
//         scrub: true,
//         onUpdate(self) {
//           updateStyles(self.progress);
//         },
//       },
//       duration: 1
//     }
//   );

//   function updateStyles(progressValue) {
//     const aboutUsElement = document.querySelector('.about-us');
//     aboutUsElement.style.transform = `scale(${progressValue > 0.08 ? 0.9 : 1 - progressValue})`;
//     aboutUsElement.style.borderRadius = `${Math.min(progressValue * 40, 40)}px`;
//   }
// };
